import { DeliveryDistributionModes, OrderTypeValues } from '@config/values/order.values';

function normalizeMode(mode: string): string {
  return mode.trim().toLowerCase();
}

/**
 * Normalizes a promotion distribution mode value to a canonical format.
 */
export function normalizePromotionDistributionMode(mode: string | null | undefined): string | null {
  if (!mode) {
    return null;
  }
  const normalized = normalizeMode(mode);
  return normalized.length ? normalized : null;
}

/**
 * Returns true when current mode is compatible with promotion allowed modes.
 * Supports legacy "delivery" allowed mode against provider delivery modes.
 */
export function modeMatchesPromotionAllowedModes(
  currentMode: string | null | undefined,
  allowedModes: readonly string[] | null | undefined,
): boolean {
  if (!allowedModes?.length) {
    return true;
  }

  const normalizedCurrentMode = normalizePromotionDistributionMode(currentMode);
  if (!normalizedCurrentMode) {
    return false;
  }

  const normalizedAllowedModes = allowedModes
    .map(mode => normalizePromotionDistributionMode(mode))
    .filter((mode): mode is string => mode !== null);

  if (!normalizedAllowedModes.length) {
    return true;
  }

  if (normalizedAllowedModes.includes(normalizedCurrentMode)) {
    return true;
  }

  const isCurrentDeliveryProvider = DeliveryDistributionModes.includes(normalizedCurrentMode);

  if (
    normalizedAllowedModes.includes(OrderTypeValues.Delivery) &&
    (isCurrentDeliveryProvider || normalizedCurrentMode === OrderTypeValues.Delivery)
  ) {
    return true;
  }

  if (
    normalizedCurrentMode === OrderTypeValues.Delivery &&
    normalizedAllowedModes.some(mode => DeliveryDistributionModes.includes(mode))
  ) {
    return true;
  }

  return false;
}
